import { render, staticRenderFns } from "./TableRestrictionTypeListSidebar.vue?vue&type=template&id=1333d310&scoped=true&"
import script from "./TableRestrictionTypeListSidebar.vue?vue&type=script&lang=js&"
export * from "./TableRestrictionTypeListSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333d310",
  null
  
)

export default component.exports